import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgxWhastappButtonModule } from "ngx-whatsapp-button";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { NosotrosComponent } from './components/nosotros/nosotros.component';
import { GaleriaComponent } from './components/galeria/galeria.component';
import { HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import { PremiocolaboraComponent } from './components/premiocolabora/premiocolabora.component';
import { PremioprincComponent } from './components/premioprinc/premioprinc.component';
import { RemanentesComponent } from './components/remanentes/remanentes.component';
import { FormComponent } from './components/form/form.component';
import { ColaboraFormComponent } from './components/colabora-form/colabora-form.component';
import { ContactComponent } from './components/contact/contact.component';
import { ReglamentobecarioComponent } from './components/reglamentobecario/reglamentobecario.component';
import { PrivacidadComponent } from './components/privacidad/privacidad.component';
import { TerminosComponent } from './components/terminos/terminos.component';
import { ConvenioComponent } from './components/convenio/convenio.component';
import { BasesorteoComponent } from './components/basesorteo/basesorteo.component';
import { MecanicaComponent } from './components/mecanica/mecanica.component';
import { FormsModule } from '@angular/forms';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeMX from '@angular/common/locales/es-MX';
import { FaqsComponent } from './components/faqs/faqs.component';
import { DatesComponent } from './components/dates/dates.component';
import { RecuperarPassComponent } from './components/recuperar-pass/recuperar-pass.component';
import { MenuLoginComponent } from './components/participantes-son/menu-login/menu-login.component';
import { PostalComponent } from './components/postal/postal.component';
import { ComparteComponent } from './components/comparte/comparte.component';
import { ComparteTextComponent } from './components/comparte-text/comparte-text.component';
import { ConsultaBoletosComponent } from './components/consulta-boletos/consulta-boletos.component';
import { BlogComponent } from './components/blog/blog.component';


import { GanadoresPrincipalesComponent } from './components/ganadores-principales/ganadores-principales.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ListaegresadosComponent } from './components/listaegresados/listaegresados.component';

import { VentamesessininteresesComponent } from './components/ventamesessinintereses/ventamesessinintereses.component';
import { FormwinnersComponent } from './components/formwinners/formwinners.component';
import { LoginComponent } from './components/login/login.component';
import { FormularioDocumentosComponent } from './components/formulario-documentos/formulario-documentos.component';
import { PuntosdeventaComponent } from './components/puntosdeventa/puntosdeventa.component';
import { BasesoportunosComponent } from './components/basesoportunos/basesoportunos.component';
import { ParticiparSorteoOportunoComponent } from './components/participar-sorteo-oportuno/participar-sorteo-oportuno.component';
import { ThanksColaboradorComponent } from './components/thanks-colaborador/thanks-colaborador.component';
import { ThanksEgresadoComponent } from './components/thanks-egresado/thanks-egresado.component';
import { GanadoressorteosoportunosComponent } from './components/ganadoressorteosoportunos/ganadoressorteosoportunos.component';
import { ParticipantessorteoptComponent } from './components/participantessorteopt/participantessorteopt.component';
import { ParticipantesTercerSorteoOportuno2026Component } from './components/participantes-tercer-sorteo-oportuno-2026/participantes-tercer-sorteo-oportuno-2026.component';
import { GanadoresTercerSorteoOportuno2026Component } from './components/ganadores-tercer-sorteo-oportuno-2026/ganadores-tercer-sorteo-oportuno-2026.component';
import { BasesegresadosComponent } from './components/basesegresados/basesegresados.component';
import { NgxYoutubePlayerModule } from 'ngx-youtube-player';
import { Participantesso2Component } from './components/participantesso2/participantesso2.component';
import { MainloginComponent } from './components/mainlogin/mainlogin.component';
import { DocumentosComponent } from './components/documentos/documentos.component';
import { GalerianuevaComponent } from './components/galerianueva/galerianueva.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ParticipantesEgresadosComponent } from './components/participantes-egresados/participantes-egresados.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ParticipantesLealtadComponent } from './components/participantes-lealtad/participantes-lealtad.component';
import { ParticipantesEgresados2026Component } from './components/participantes-egresados-2026/participantes-egresados-2026.component';
import { SorteoPrepasComponent } from './components/sorteo-prepas/sorteo-prepas.component';
import { SorteoPrepasGanadorComponent } from './components/sorteo-prepas-ganador/sorteo-prepas-ganador.component';
import { ParticipantesSegundoSorteoOportuno2026Component } from './components/participantes-segundo-sorteo-oportuno-2026/participantes-segundo-sorteo-oportuno-2026.component';
import { GanadoresSegundoSorteoOportuno2026Component } from './components/ganadores-segundo-sorteo-oportuno-2026/ganadores-segundo-sorteo-oportuno-2026.component';
import { GanadoresEgresados2026Component } from './components/ganadores-egresados-2026/ganadores-egresados-2026.component';
import { ParticipantesAmigoComponent } from './components/participantes-amigo/participantes-amigo.component';
import { ParticipantesSONComponent } from './components/participantes-son/participantes-son.component';
import { Ganadorso2Component } from './components/ganadorso2/ganadorso2.component';
import { GanadorresegresadosComponent } from './components/ganadorresegresados/ganadorresegresados.component';
import { GanadorSo3Component } from './components/ganador-so3/ganador-so3.component';
import { GanadoresmagnoComponent } from './components/ganadoresmagno/ganadoresmagno.component';
import { SafeUrlPipe } from './components/galerianueva/safe-url.pipe';
import { BasesaniversarioComponent } from './components/basesaniversario/basesaniversario.component';
import { PremiosaniversarioComponent } from './components/premiosaniversario/premiosaniversario.component';
import { EgresadosanivComponent } from './components/egresadosaniv/egresadosaniv.component';
import { HomePilotoComponent } from './components/home-piloto/home-piloto.component';
import { HomePiloto2Component } from './components/home-piloto-2/home-piloto-2.component';
import { PremiosCalleComponent } from './components/premios-calle/premios-calle.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginWalletComponent } from './components/login-wallet/login-wallet.component';
import { DashboardWalletComponent } from './components/dashboard-wallet/dashboard-wallet.component';
import { JwtInterceptor } from 'src/services/jwt.interceptor';

registerLocaleData(localeMX);



 


@NgModule({

  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    NosotrosComponent,
    GaleriaComponent,
    PremiocolaboraComponent,
    PremioprincComponent,
    RemanentesComponent,
    FormComponent,
    ColaboraFormComponent,
    ContactComponent,
    ReglamentobecarioComponent,
    PrivacidadComponent,
    TerminosComponent,
    ConvenioComponent,
    BasesorteoComponent,
    MecanicaComponent,
    FaqsComponent,
    DatesComponent,
    RecuperarPassComponent,
    MenuLoginComponent,
    PostalComponent,
    ComparteComponent,
    ComparteTextComponent,
    ConsultaBoletosComponent,
    BlogComponent,
    GanadoresPrincipalesComponent,
    ListaegresadosComponent,
    VentamesessininteresesComponent,
    FormwinnersComponent,
    LoginComponent,
    FormularioDocumentosComponent,

    PuntosdeventaComponent,

    BasesoportunosComponent,

    ParticiparSorteoOportunoComponent,
     ThanksColaboradorComponent,
     ThanksEgresadoComponent,
     GanadoressorteosoportunosComponent,
     ParticipantessorteoptComponent,
     ParticipantesTercerSorteoOportuno2026Component,
     GanadoresTercerSorteoOportuno2026Component,
     BasesegresadosComponent,
     Participantesso2Component,
     MainloginComponent,
     DocumentosComponent,
     GalerianuevaComponent,
     ParticipantesEgresadosComponent,
     ParticipantesLealtadComponent,
     ParticipantesEgresados2026Component,
     SorteoPrepasComponent,
     SorteoPrepasGanadorComponent,
     ParticipantesSegundoSorteoOportuno2026Component,
     GanadoresSegundoSorteoOportuno2026Component,
     GanadoresEgresados2026Component,
     ParticipantesAmigoComponent,
     ParticipantesSONComponent,
     Ganadorso2Component,
     GanadorresegresadosComponent,
     GanadorSo3Component,
     GanadoresmagnoComponent,
     SafeUrlPipe,
     BasesaniversarioComponent,
     PremiosaniversarioComponent,
     EgresadosanivComponent,
     HomePilotoComponent,
     HomePiloto2Component,
     PremiosCalleComponent,
     LoginWalletComponent,
     DashboardWalletComponent,


  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    NgxWhastappButtonModule,
    SlickCarouselModule,
    NgxYoutubePlayerModule,
    FontAwesomeModule,
    NgxPaginationModule,
    NgbModule

  ],
  providers: [{ provide: LOCALE_ID, useValue: 'es-MX' }, { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }


